// Thin wrapper around sonner. Existed originally as a wrapper around
// react-hot-toast; migrated so the whole app shares one toast library
// (sonner Toaster mounted in App.js). Public API kept identical so all
// existing showSuccess/showError/Toast.* callers keep working without
// any changes.
import { toast } from "sonner";

export const showSuccess = (message, options = {}) =>
  toast.success(message, options);

export const showError = (message, options = {}) =>
  toast.error(message, options);

export const showInfo = (message, options = {}) =>
  toast.info(message, options);

export const showWarning = (message, options = {}) =>
  toast.warning(message, options);

export const showLoading = (message, options = {}) =>
  toast.loading(message, options);

export const dismissToast = (id) => toast.dismiss(id);

const Toast = {
  showSuccess,
  showError,
  showInfo,
  showLoading,
  dismissToast,
  showWarning,
};

export default Toast;
